module.exports = __webpack_public_path__ + "static/media/Våt.aa93670d.PNG";